var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex-start-center gap-5" }, [
    _vm.label
      ? _c("label", { staticClass: "mb-0", attrs: { for: _vm.id } }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "activation" }, [
      _c(
        "label",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch",
              value: _vm.toggle,
              expression: "toggle",
            },
          ],
          staticClass: "switch on-off",
          class: { withTxt: _vm.on || _vm.off, xs: !(_vm.on || _vm.off) },
          attrs: { for: _vm.id },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.val,
                expression: "val",
              },
            ],
            attrs: { type: "checkbox", id: _vm.id, disabled: _vm.disabled },
            domProps: {
              checked: Array.isArray(_vm.val)
                ? _vm._i(_vm.val, null) > -1
                : _vm.val,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.val,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.val = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.val = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "slider round", attrs: { a: "bg-white" } },
            [
              _c("small", { staticClass: "flex-center-center h-100" }, [
                _vm._v(_vm._s(_vm.value ? _vm.on : _vm.off)),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }